// Recovered compiled webpack factory 36874. Edit this function expression; run npm run build.
(t, e, i) => {
  i.d(e, { N: () => n });
  function n(t) {
    return null !== t && "object" == typeof t && "function" == typeof t.start;
  }
}
